<template>
  <div class="right-side right-side-reverse">
    <ul class="vertical-menu">
      <li :class="{'active':routeName==='general' }"><router-link to="/settings/general"><span class="icon-wrp"><img :src="require('@/assets/images/user.png')" alt="icon"/></span>General Settings</router-link></li>
      <li :class="{'active':routeName==='position' }"><router-link to="/settings/position"><span class="icon-wrp"><img :src="require('@/assets/images/Hours.png')" alt="icon" /></span>Job Roles</router-link></li>
      <li :class="{'active':routeName==='location' }"><router-link to="/settings/location"><span class="icon-wrp"><img :src="require('@/assets/images/SalarySlip.png')" alt="icon" /></span>Location</router-link></li>
      <li :class="{'active':routeName==='administrators' }"><router-link to="/settings/administrators"><span class="icon-wrp"><img :src="require('@/assets/images/Employment.png')" alt="icon" /></span>Administrators</router-link></li>
      <li :class="{'active':routeName==='leaves' }"><router-link to="/settings/leaves"><span class="icon-wrp"><img :src="require('@/assets/images/Employment.png')" alt="icon" /></span>leaves Setting</router-link></li>
      <li :class="{'active':routeName==='holidays' }"><router-link to="/settings/holidays"><span class="icon-wrp"><img :src="require('@/assets/images/Employment.png')" alt="icon" /></span>Holidays</router-link></li>
      <li :class="{'active':routeName==='work-shift' }"><router-link to="/settings/work-shift"><span class="icon-wrp"><img :src="require('@/assets/images/Employment.png')" alt="icon" /></span>Work Shift</router-link></li>
      <li :class="{'active':routeName==='assign-shift' }"><router-link to="/settings/assign-shift"><span class="icon-wrp"><img :src="require('@/assets/images/Employment.png')" alt="icon" /></span>Assign Shift</router-link></li>
      <li :class="{'active':routeName==='change-password' }"><router-link to="/settings/change-password"><span class="icon-wrp"><img :src="require('@/assets/images/Employment.png')" alt="icon" /></span>Change Password</router-link></li>
    </ul>
    <div class="mt-auto">
<!--      <a href="#" class="btn btn-info btn-block" >Loge out</a>-->
      <logout :className="'btn btn-info btn-block'"></logout>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";
import logout from "../Partials/logout";
export default {
  components:{
    logout
  },
  props: [],
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      routeName:this.$route.name,
    }
  },
  serverPrefetch() {
  },
  created() {
  },
  mounted() {
  },
  methods: {

  }
}
</script>
